import React, { useCallback } from 'react';
import {
  Box,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Collapse
} from '@mui/material';

import DebouncedTextField from '../../Utils/debounce';

export default function CuteMucose({ parameters, setParameters }) {

  const set = (key, value) =>
    setParameters(prev => ({ ...prev, [key]: value }));

  const setField = useCallback((key, value) => {
    setParameters(prev => ({ ...prev, [key]: value }));
  }, []);

  const toggleRadio = (key, newValue) =>
    set(key, parameters[key] === newValue ? '' : newValue);

  const p = parameters;

  return (
    <Box sx={{ width: '50ch', display: 'grid', gap: 2 }}>

      <Box sx={{ p: 3, mb: 2, border: '1px solid rgba(0,0,0,0.23)', borderRadius: 2, backgroundColor: '#f5f5f5', textAlign: 'center' }}>
        <Box component="h1" sx={{ m: 0, fontSize: '1.8rem', fontWeight: 'bold', color: '#1976d2' }}>
          Accertamento Infermieristico
        </Box>
        <Box component="p" sx={{ m: 0, mt: 1, fontSize: '1rem', color: 'text.secondary' }}>
          Cute e mucose
        </Box>
      </Box>


      <FormControl sx={{ flexDirection: 'row', gap: 2, alignItems: 'center' }}>
        <FormLabel sx={{ minWidth: 160 }}>Mucosa orale alterata</FormLabel>
        <RadioGroup row value={p.mucosa ?? ''}>
          <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('mucosa', 'true')}  />} label="Sì" />
          <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('mucosa', 'false')} />} label="No" />
        </RadioGroup>
        {p.mucosa === 'true' && (
          <DebouncedTextField size="small" label="Tipo di alterazione"
            value={p.tipoMucosa ?? ''}
            onChange={(val) => setField('tipoMucosa', val)} />
        )}
      </FormControl>

      <FormControl sx={{ flexDirection: 'row', gap: 2, alignItems: 'center' }}>
        <FormLabel sx={{ minWidth: 160 }}>Catetere venoso</FormLabel>
        <RadioGroup row value={p.cvc ?? ''}>
          <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('cvc', 'true')}  />} label="Sì" />
          <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('cvc', 'false')} />} label="No" />
        </RadioGroup>
        <Collapse in={p.cvc === 'true'}>
          <FormControl sx={{ flexDirection: 'column', gap: 2 }}>
            <DebouncedTextField size="small" label="Tipo di catetere"
              value={p.tipoCvc ?? ''}
              onChange={(val) => setField('tipoCvc', val)} />
            <DebouncedTextField size="small" label="Sede"
              value={p.sedeCvc ?? ''}
              onChange={(val) => setField('sedeCvc', val)} />
            <DebouncedTextField size="small" type="date" label="Data posizionamento" InputLabelProps={{ shrink: true }}
              value={p.dataCvc ?? ''}
              onChange={(val) => setField('dataCvc', val)} />
          </FormControl>
        </Collapse>
      </FormControl>

      {[
        ['Cute idratata', 'cuteIdratata'],
        ['Ascite',        'ascite'],
        ['Cianotica',     'cianosi'],
        ['Itterica',      'ittero'],
        ['Pallida',       'pallore'],
        ['Integra',       'cuteIntegra'],
      ].map(([label, key]) => (
        <FormControl key={key} sx={{ flexDirection: 'row', gap: 2, alignItems: 'center' }}>
          <FormLabel sx={{ minWidth: 160 }}>{label}</FormLabel>
          <RadioGroup row value={p[key] ?? ''}>
            <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio(key, 'true')}  />} label="Sì" />
            <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio(key, 'false')} />} label="No" />
          </RadioGroup>
        </FormControl>
      ))}

      <FormControl sx={{ flexDirection: 'row', gap: 2, alignItems: 'center' }}>
        <FormLabel sx={{ minWidth: 160 }}>Edemi</FormLabel>
        <RadioGroup row value={p.edemi ?? ''}>
          <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('edemi', 'true')}  />} label="Sì" />
          <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('edemi', 'false')} />} label="No" />
        </RadioGroup>
        {p.edemi === 'true' && (
          <DebouncedTextField size="small" label="Posizione edemi"
            value={p.posizioneEdemi ?? ''}
            onChange={(val) => setField('posizioneEdemi', val)} />
        )}
      </FormControl>

      <FormControl sx={{ flexDirection: 'row', gap: 2, alignItems: 'center' }}>
        <FormLabel sx={{ minWidth: 160 }}>Lesioni</FormLabel>
        <RadioGroup row value={p.lesioni ?? ''}>
          <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('lesioni', 'true')}  />} label="Sì" />
          <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('lesioni', 'false')} />} label="No" />
        </RadioGroup>
        {p.lesioni === 'true' && (
          <>
            <DebouncedTextField size="small" label="Tipo e sede"
              value={p.tipoLesione ?? ''}
              onChange={(val) => setField('tipoLesione', val)} />
            <DebouncedTextField size="small" label="Medicazione utilizzata"
              value={p.medicazione ?? ''}
              onChange={(val) => setField('medicazione', val)} />
          </>
        )}
      </FormControl>

      <FormControl sx={{ flexDirection: 'row', gap: 2, alignItems: 'center' }}>
        <FormLabel sx={{ minWidth: 160 }}>Ulcere da pressione</FormLabel>
        <RadioGroup row value={p.ulcere ?? ''}>
          <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('ulcere', 'true')}  />} label="Sì" />
          <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('ulcere', 'false')} />} label="No" />
        </RadioGroup>
        {p.ulcere === 'true' && (
          <>
            <DebouncedTextField size="small" label="Posizione"
              value={p.posizioneUlcere ?? ''}
              onChange={(val) => setField('posizioneUlcere', val)} />
            <DebouncedTextField size="small" label="Stadio"
              value={p.stadioUlcere ?? ''}
              onChange={(val) => setField('stadioUlcere', val)} />
          </>
        )}
      </FormControl>

    </Box>
  );
}